import React, { useEffect, useState } from "react";
import "@Styles/mandate.css";
import staticProfile from "@Images/NewUI/staticimg.png";
import email_img from "@Images/NewUI/email.png";
import smartphone from "@Images/NewUI/smartphone.png";
import logout_icon from "@Images/NewUI/logou.png";
import ProfileHistory from "@Images/NewUI/profHistory.png";
import ArrowIcon from "@Images/NewUI/perpicon.png";
import Policy from "@Images/NewUI/policy.png";
import ProfileEdit from "@Images/NewUI/profileedit.png";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { profilePicture , chatbotWebView , chatbotTicketView } from "../../../Redux/ApplyLoan/action";
import { getDocumentStatus,referandearndiraction } from "../../../Redux/Manual_Kyc_Details/action";
import { getUserDetail } from "../../../Redux/GeneralDetails/action";
import close from "../../../../src/Images/NewUI/close.png";
import ToastMsg from "../../../helper/ToastMsg";

const ProfileMenu = (props) => {
  let token = props?.user?.manual_token || localStorage.getItem("gpay_token");
  const [profilePicture, setProfilePicture] = useState();
  const [loader, setLoader] = useState(false);
  const [plJourneyCheck , setPlJourneyCheck] = useState(false)
  
  
  const handleChatBotClick = () => {
    const token = props.token || localStorage.getItem("gpay_token");
    if (token) {
      handleChatbotUrlFunction(token);
    } else {
      console.error("Support missing");
      ToastMsg("Support missing", "error");
    }
  };

  
  const handleChatbotUrlFunction = (token) => {
    
    props.chatbotWebView(token)
      .then((res) => {
        
        console.log("Chatbot API response:", res);

        const chatbotUrl = res.data.url;
        window.open(chatbotUrl, "_blank");
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.removeItem("gpay_token");
          window.location.href = "/";
          return;
        }

        const error = err?.response?.data?.error || "Something went wrong!";
        ToastMsg(error, "error");
      });
  };

  const handleChatbotTicketUrlFunction = (token) => {
    props.chatbotTicketView(token)
      .then((res) => {
        console.log("Chatbot API response:", res);

        const chatbotUrl = res.data.url;
        window.open(chatbotUrl, "_blank");
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.removeItem("gpay_token");
          window.location.href = "/";
          return;
        }

        const error = err?.response?.data?.error || "Something went wrong!";
        ToastMsg(error, "error");
      });
  };
  

  
  
  const handleMyTicketsClick = () => {
    
  
  
    const token = props?.token || localStorage.getItem("gpay_token");
  
    if (token) {
      
      handleChatbotTicketUrlFunction(token);
    }
  
  };
  
  
    
  const checkBankVerified = () => {
    setLoader(true)
    let token = localStorage.getItem("gpay_token");
    props.getDocumentStatus(token)
      .then((res) => {
        
        res.data.map((details) => {
          setPlJourneyCheck(details?.pl_journey)
        //  console.log(details.pl_journey, "details get doc status");

         
        });
      })
      .catch((err) => {
        setLoader(false)
        if (err.response?.status === 401) {
        //  window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        
      });
  };

  // console.log(props.userDetail?.user_detail?.id, "user id");

  const handleReferandEarn = () => {
   
  
    let token = props.token || localStorage.getItem("gpay_token");
    props.referandearndiraction(token)
      .then((res) => {
        // console.log(res, "res of web view url");
        
        setTimeout(() => {
          window.open(res.data.url, '_blank');
        }, 100); 
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleprofilePicture = () => {
    props
      .profilePicture("", token)
      .then((res) => {
        setProfilePicture(res?.data?.presigned_url);
        // console.table("response loan history", res);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
        //  window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  useEffect(() => {

    props
    .getUserDetail(token)
    .then((res) => {
      if (res.status === 200) {
        console.log("User details fetched successfully:", res?.email);
        console.log("User details fetched successfully:", res?.customusermodel?.first_name);
        console.log("User details fetched successfully:", res?.customusermodel?.first_name);
        
        
      } else {
        console.error("Unexpected response:", res);
      }
    })
    .catch((error) => {
      console.error("Error fetching user details:", error);
    });
  

   
    handleprofilePicture();
    checkBankVerified()
  }, []);

  const handleLogout = () => {
    localStorage.clear()
    window.location.href = "/";
  };

  return (
    <div id="background" className="main_div ">
    <div className="container centerer">
      <div className="pb-4 ">
        <div className="mt-50"></div>
        <div className="profile_upper_info flex align-center">
          <img
            src={profilePicture ? profilePicture : staticProfile}
            className="profilepicturesize"
            alt="profile"
          />
          <div className="right_p_info">
            <p className="user_p_name">
              {props?.userDetail?.user_detail?.customusermodel?.first_name
                .split(" ")[0]
                .charAt(0)
                .toUpperCase() +
                props?.userDetail?.user_detail?.customusermodel?.first_name
                  .split(" ")[0]
                  .slice(1)
                  .toLowerCase() || "User"}
            </p>
            <span className="user_email mb-10">
              <img src={email_img} alt="email" />
              {props?.userDetail?.user_detail?.email}
            </span>
            <div className="flex ">
              <span className="user_no">
                <img src={smartphone} alt="smartphone" />
                {props?.userDetail?.user_detail?.customusermodel?.phone_number}
              </span>
              <Link
                to={{ pathname: "/profile_view", profile_pic: profilePicture }}
              >
                <img className="ml-10" src={ProfileEdit} width={24} alt="logout" />
              </Link>
            </div>
          </div>
        </div>
  
        <div className="profile_lower_sc">
          <ul>
            <span className="section-heading profileheading">User Account & Transactions</span>
            <hr className="horizontallineprofile" />
  
            <Link to="/loanhistory">
              <li className="profileMenutext flex space-between align-center">
                <div className="flex align-center">
                  <img src={ProfileHistory} style={{ marginRight: "5px" }} width={25} alt="History Icon" />
                  History
                </div>
                <img src={ArrowIcon} width={7} height={10} />
              </li>
            </Link>
  
            <span className="section-heading profileheading">Customer Support & Information</span>
            <hr className="horizontallineprofile" />
            <Link to="/new_policies">
              <li className="profileMenutext flex space-between align-center">
                <div className="flex align-center">
                  <img src={Policy} style={{ marginRight: "5px" }} width={25} alt="Policies Icon" />
                  Policies
                </div>
                <img src={ArrowIcon} width={7} height={10} />
              </li>
            </Link>
            <hr className="horizontallineprofile" />
            <Link
  to="#"
  onClick={() => {
    handleLogout();
  }}
>
  <li className="profileMenutext flex space-between align-center">
    <div className="flex align-center">
      <img src={logout_icon} alt="Logout Icon" style={{ marginRight: "5px" }} width={25} />
      Logout
    </div>
  </li>
</Link>

          </ul>
        </div>
  
        <span className="headingprofile_menu_updated">
          <img
            className="profilemenuxbtn_updated"
            style={{ cursor: "pointer" }}
            src={close}
            onClick={() => {
              window.location.href = "/dashboard_s";
            }}
          />
        </span>
      </div>
    </div>
  </div>
  
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};
export default connect(mapStateToProps, { profilePicture,referandearndiraction,getUserDetail,chatbotWebView, chatbotTicketView, getDocumentStatus })(ProfileMenu);